import { useEffect, useState } from "react";
import api from "../lib/api";
import ProductCard from "../components/ProductCard";
import { Flame } from "lucide-react";

export default function Promociones() {
    const [products, setProducts] = useState([]);

    useEffect(() => {
        api.get("/products", { params: { category: "Promociones" } }).then(({ data }) => setProducts(data));
    }, []);

    return (
        <div data-testid="promociones-page">
            <section className="bg-gradient-to-br from-marigold to-mexred text-cocoa">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 text-center">
                    <Flame className="w-12 h-12 mx-auto mb-3" />
                    <h1 className="font-display text-4xl md:text-5xl font-semibold mb-2">¡Promociones picosas! 🔥</h1>
                    <p className="text-cocoa/80">Las mejores salsas, micheladas y combos al mejor precio.</p>
                </div>
                <div className="fiesta-stripes h-2 w-full" />
            </section>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
                {products.length === 0 ? (
                    <p className="text-center text-muted-foreground py-10">Pronto tendremos promociones increíbles.</p>
                ) : (
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
                        {products.map((p) => (
                            <ProductCard key={p.id} product={p} />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
